import { useEffect, useState } from "react";
import axios from "axios";
import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";

interface ProductRangesParams {
  productCompany: string;
  archived: boolean;
}

export function useProductRanges({ productCompany, archived }: ProductRangesParams) {
  const [productRanges, setProductRanges] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchProductRanges = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {
          const params =
          {
            ProductCompany: productCompany,
            Archived: archived,
          };
          const config = {
            headers: { Authorization: `Bearer ${token}` },
            params: params,
          };
          const apiResponse = await axios.get(
            process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/ProductRanges",
            config
          );
          const productRangeList = apiResponse.data.map((productRange: any) => ({
            key: productRange.range,
            label: productRange.description,
          }));
          setProductRanges(productRangeList);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchProductRanges();
  }, [productCompany, archived]);

  return { productRanges, loading };
}